import { makeStyles } from '@material-ui/core/styles';
import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import PreviousDoctors from '@/components/Dashboard/previous-doctors.jsx';
import { UpcomingAppointments } from '@/components/Dashboard/upcoming-appointments.tsx';
import Loader from '@/components/Loader.jsx';
import LocationTreatments from '@/components/Search/LocationTreatments.jsx';
import SearchHero from '@/components/Search/SearchHero.jsx';

import { ContextProvider } from '@/context/ProjectContext.jsx';

import { useSearchRestingState } from '@/hooks/use-search-resting-state.js';

import { usePersistedPrismicStore } from '@/store.js';

const useStyles = makeStyles((theme) => ({
    contentContainerBody: {
        maxWidth: theme.layout.contentWidth,
        // A flex gap rather than margins on each section: sections render conditionally, and a
        // margin on one of them disappears with it or collapses against its neighbour.
        display: 'flex',
        flexDirection: 'column',
        gap: '2.5rem',
        marginTop: '-2rem',
        marginLeft: 'auto',
        marginRight: 'auto',
        paddingLeft: 50,
        paddingRight: 50,
        [theme.breakpoints.down('xs')]: {
            paddingLeft: 20,
            paddingRight: 20,
        },
    },
}));

const Dashboard = () => {
    const classes = useStyles();
    const { i18n } = useTranslation();
    const { openLogin, setOpenLogin } = useContext(ContextProvider);
    const isRestingState = useSearchRestingState();

    const {
        [i18n.language]: { dataSet },
    } = usePersistedPrismicStore((state) => state.dashboardData);

    useEffect(() => {
        if (openLogin) setOpenLogin(false);

        // returning back to top on mount
        window.scrollTo(0, 0);
    }, []);

    if (!dataSet) return <Loader />;

    return (
        <>
            <SearchHero showBrowse={false} />

            {isRestingState && (
                <div className={classes.contentContainerBody}>
                    <UpcomingAppointments />
                    <LocationTreatments />
                    <PreviousDoctors />
                </div>
            )}
        </>
    );
};

export default Dashboard;
